<template>
  <div>
    <md-table>
      <md-table-toolbar class="md-layout md-gutter">
        <h1 class="titulo md-title md-layout-item md-size-100">
          Ações Automáticas
        </h1>
        <div class="md-layout-item md-size-75">
          <md-autocomplete v-model="acaoSelected" :md-options="acaoSearch">
            <label>Ações</label>
          </md-autocomplete>
        </div>
        <div class="md-layout-item">
          <md-button class="md-primary md-raised" @click="adicionaAcao">
            Adicionar
          </md-button>
        </div>
      </md-table-toolbar>
      <md-table-row>
        <md-table-head>Ações</md-table-head>
        <md-table-head />
      </md-table-row>
      <md-table-row
        v-for="acao in notificacaoAcoes"
        :key="acao.id"
        class="pt-2 pb-2"
      >
        <md-table-cell>
          <div class="md-layout md-alignment-center-left">
            <div class="md-layout-item md-size-10">
              <md-icon
                class="md-primary"
                :style="{
                  ['background-color']: acao.cor,
                  ['border-radius']: '2px',
                  ['min-height']: '2vh',
                  ['min-width']: '2vh',
                }"
              />
            </div>
            <div class="md-layout-item">
              <span>{{
                acao.equipamentoNome + ' - ' + acao.nomeExibicao
              }}</span>
            </div>
          </div>
        </md-table-cell>
        <md-table-cell class="md-toolbar-section-end">
          <md-button
            class="md-raised md-accent"
            @click="() => removeAcao(acao.id)"
          >
            Remover
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import { EventBus, Topics, Types } from '@/event-bus'

import http from '../../utils/http'

export default {
  name: 'NotificacaoAcoes',
  props: {
    localId: String,
    notificacaoAcaosId: Array,
  },
  data() {
    return {
      acoesCidade: [],
      acaoSearch: [],
      acaoSelected: '',
      notificacaoAcoes: [],
    }
  },
  async beforeMount() {
    this.acoesCidade = (
      await http.get(`local/${this.localId}/acao/botoes`)
    ).botoes
    this.acaoSearch = this.acoesCidade.map(
      (e) => e.equipamentoNome + ' - ' + e.nomeExibicao
    )
    this.notificacaoAcoes = this.acoesCidade.filter((e) =>
      this.notificacaoAcaosId.includes(e.id)
    )
  },
  methods: {
    adicionaAcao() {
      const acao = this.acoesCidade.find(
        (e) => e.equipamentoNome + ' - ' + e.nomeExibicao === this.acaoSelected
      )

      if (acao == null) {
        return
      }

      if (this.notificacaoAcoes.some((e) => e.id === acao.id)) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Ação já adicionada',
        })
        return
      }

      this.acaoSelected = ''
      this.notificacaoAcoes.push(acao)
      this.$emit('modificaNotificacaoAcoes', this.notificacaoAcoes)
    },
    removeAcao(acaoId) {
      this.notificacaoAcoes = this.notificacaoAcoes.filter(
        (e) => e.id !== acaoId
      )
      this.$emit('modificaNotificacaoAcoes', this.notificacaoAcoes)
    },
  },
}
</script>
<style lang="scss" scoped>
.titulo {
  padding-top: 38px;
}
</style>
